module.exports = __webpack_public_path__ + "static/img/sstop_en.0ce37be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/sstop_en.png
// module id = 5U1L
// module chunks = 0